export const REQUEST_RELATED_ENTITIES = 'REQUEST_RELATED_ENTITIES';
export const REQUEST_RELATED_ENTITIES_SUCCESS = 'REQUEST_RELATED_ENTITIES_SUCCESS';
export const REQUEST_RELATED_ENTITIES_ERROR = 'REQUEST_RELATED_ENTITIES_ERROR';

export const requestRelatedEntitiesAction = ({ ids }) => ({
  type: REQUEST_RELATED_ENTITIES,
  payload: {
    ids,
  },
});
